import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
	selector: 'app-ios-toggle',
	templateUrl: './ios-toggle.component.html',
	styleUrls: ['./ios-toggle.component.scss'],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => IosToggleComponent),
			multi: true
		}
	]
})
export class IosToggleComponent implements OnInit, ControlValueAccessor {

	@Input() checked: boolean;
	@Input() label: string;

	model: boolean;

	constructor() {}

	ngOnInit() {
	}

	writeValue(value: any) {
		this.model = value;
	}

	propagateChange = (_: any) => {};

	registerOnChange(fn) {
		this.propagateChange = fn;
	}

	registerOnTouched() {}

}
